<template>
  <b-modal 
    v-model="user.showProfile" 
    modal-class="side-modal" 
    static
    no-enforce-focus
  >
    <div class="profile-content">
      <h2>My Profile</h2>
      <div class="profile-group profile-user">
        <label>{{ user.firstName }} {{ user.lastName }}</label>
        <div>{{ user.email }}</div>
      </div>
      <div v-if="user.phoneNumber" class="profile-group">
        <label>Phone</label>
        <div>{{ user.phoneNumber }}</div>
      </div>
      <div v-if="user.birthDate" class="profile-group">
        <label>Birth date</label>
        <div>{{ birthDate }}</div>
      </div>
      <div v-if="user.address && (user.address.address1 || user.address.address2)" class="profile-group">
        <label>Address</label>
        <div>
          <div v-if="user.address.address1">
            {{ user.address.address1 }},
          </div>
          <div v-if="user.address.address2">
            {{ user.address.address2 }},
          </div>
          <div>{{ user.address.city }}, {{ user.address.state }}, {{ user.address.zip }}</div>
        </div>
      </div>
      <div v-if="hasApiAccess">
        <a class="nav-link api-button" @click="viewApiKeys()">API Keys</a>
      </div>
    </div>
    <div slot="modal-footer">
      <div class="profile-footer">
        <b-btn @click="edit" v-if="!isInProfile" variant="light">Edit</b-btn>
        <b-btn @click="logout" variant="light">Log Out</b-btn>
        <a class="nav-link admin-btn" v-if="loggedInAsUser" @click="backToAdmin">Back to {{ backToUserText }}</a>
      </div>
    </div>
  </b-modal>
</template>
<script>
  import { createNamespacedHelpers } from 'vuex';
  const { mapState, mapMutations, mapActions } = createNamespacedHelpers('user');

  import moment from 'moment';

  export default {
    data() {
      return { };
    },
    
    computed: {
      ...mapState(["user"]),

      birthDate() { 
        return moment(this.user.birthDate).format("MM/DD/YYYY");
      },
      isInProfile() {
        return this.$route.path === '/profile/edit';
      },
      loggedInAsUser() {
        return this.$auth.isLoggedInAsAnotherUser;
      },
      hasApiAccess() {
        return this.$auth.userInfo.roles.some(r => r === "Admin" || r === "Client");
      },
      backToUserText() {
        return JSON.parse(localStorage.getItem("loggedInUser")).roles[0];
      }
    },

    methods: {
      ...mapActions(["getCurrentUser", "loginBackAsAdmin"]),
      ...mapMutations(["setShowProfile"]),

      edit() {
        this.setShowProfile(false);
        this.$router.push("/profile/edit");
      },

      async logout() {
        this.setShowProfile(false);
        await this.$auth.logout("/");
      },

      async backToAdmin() {
        await this.loginBackAsAdmin();
      },

      viewApiKeys() {
        this.$router.push("/profile/api")
      }
    },
    async created() {
      await this.getCurrentUser();
    }
  };
</script>
<style lang="scss" scoped>
  @import "@/styles/variables";

  .profile-content {
    h2 {
      font-weight: 300;
      font-size: 1.5rem;
      margin-bottom: 2.5rem;
    }
    
    .profile-group {
      margin-bottom: 2.52rem;

      > label {
        text-transform: uppercase;
        font-size: .8125rem;
        color: $body-color;
        line-height: 1.125;
        font-weight: 500;
      }

      > div {
        color: $text-color;
        font-weight: 500;
        font-size: 1.125rem;
      }

      &.profile-user {
        > label {
          font-size: 1.3125rem;
          font-weight: $font-weight-bold;
          color: $text-color;
          text-transform: initial;
        }

        > div {
          font-size: 1.125rem;
          color: $body-color;
        }
      }
    }
  }

  .profile-footer {
    white-space: nowrap;
    display: flex;

    .btn {
      & + .btn {
        margin-left: 1.125rem;
      }
    }
  }

  .admin-btn {
      align-self: center;
      cursor: pointer;
  }
  
  .api-button {
    padding-left: 0;
    cursor: pointer;
    font-weight: bold;
  }
</style>